import React from 'react'

import styles from './LoadingPanel.css'

export type LoadingPanelProps = {
  containerSize?: 'fit' | 'full' | 'mini'
  'data-testid'?: string
}

export const LoadingPanel = ({
  containerSize = 'fit',
  'data-testid': dataTestId = 'components-elements-loading-panel',
}: LoadingPanelProps) => (
  <div
    className={styles[`containerSize-${containerSize}`]}
    data-testid={dataTestId}
  >
    <div className="k-loading-mask">
      <span className="k-loading-text">Loading</span>

      <div className="k-loading-image" />

      <div className="k-loading-color" />
    </div>
  </div>
)
